import React, { FC } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { gray, blackGray, media, darkGray } from '../../utils/styles';
import { rhythm } from '../../utils/typography';
import { Image } from '../Image';
import { RemoteWorkQuery } from '../../../graphql-types';
import { FluidObject } from 'gatsby-image';
import { Strong } from '../Strong';

const AuthorsGridWrap = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  margin: ${rhythm(1)} -${rhythm(1 / 2)};
`;

const AuthorImg = styled(Image)`
  width: 100%;
  height: 140px;
  ${media.mobileS` height: 180px; `}
`;

const AuthorName = styled.h3`
  margin: 18px 0 4px 0;
`;

const Author = styled(Link)`
  flex-basis: 25%;
  ${media.tablet` flex-basis: 33%; `}
  ${media.mobileL` flex-basis: 50%; `}
  ${media.mobileS` flex-basis: 100%; `}

  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  padding: ${rhythm(1)} ${rhythm(1 / 2)};

  &:hover {
    cursor: pointer;
  }
  
  &:hover ${AuthorImg} {
    transform: translateY(-2px);
    box-shadow: 0 4px 4px -2px ${gray};
  }
  
  &:hover ${AuthorName} {
    color: ${blackGray};
  }
`;

const JobTitle = styled.span`
  color: ${darkGray};
`;

const ResourcesCount = styled.span`
  margin-top: ${rhythm(1 / 3)};
  font-size: ${rhythm(1 / 2)};
  font-style: italic;
  color: ${gray};
`;

export type AuthorsGridProps = {
  authors: RemoteWorkQuery['authors'];
};

export const AuthorsGrid: FC<AuthorsGridProps> = ({ authors }) => (
  <AuthorsGridWrap>
    {authors.edges.map(({ node }) => {
      const author = node.data;
      const [localFile] = author?.picture?.localFiles || [];
      const pictureFluid = localFile?.childImageSharp?.fluid;
      return (
        author && (
          <Author key={node.id} to={`/remote-work/${author.slug}`}>
            {pictureFluid && <AuthorImg fluid={pictureFluid as FluidObject} />}
            <AuthorName>{author.name}</AuthorName>
            <JobTitle>{author.jobTitle}</JobTitle>
            <ResourcesCount>
              <Strong>{author.publications?.length}</Strong> resources
            </ResourcesCount>
          </Author>
        )
      );
    })}
  </AuthorsGridWrap>
);
